module.exports = __webpack_public_path__ + "static/media/gestion.3bfaa2c6.jpg";